import { type FunctionComponent, type PropsWithChildren } from 'react';
import { createPortal } from 'react-dom';
import cn from 'classnames';
import { VStack } from '@direct-frontend/components';
import { useIsDesktop } from '../../../../lib/hooks';
import { useDrawerContext } from '../../DrawerContext';
import styles from './DrawerBottomFixed.module.css';

type DrawerBottomFixed = PropsWithChildren & {
    isSticky?: boolean;
};

const FixedContainer: FunctionComponent<DrawerBottomFixed> = ({ children, isSticky }) => {
    const {
        scroll: { isScrolling },
    } = useDrawerContext();

    return (
        <VStack
            className={cn(styles.sticky, {
                [styles.sticky__sticky]: isSticky,
                [styles.sticky__bordered]: isSticky && isScrolling,
            })}
        >
            {children}
        </VStack>
    );
};

export const DrawerBottomFixed: FunctionComponent<DrawerBottomFixed> = ({ children, isSticky = true }) => {
    const {
        refs: { drawerRef },
    } = useDrawerContext();

    const { isDesktop } = useIsDesktop();

    if (isDesktop) {
        return <FixedContainer isSticky={isSticky}>{children}</FixedContainer>;
    }

    return (
        <VStack className={styles.static}>
            {/* eslint-disable-next-line react-hooks/refs -- Автоматический игнор в рамках DIRECT-288723*/}
            {drawerRef.current ? (
                // eslint-disable-next-line react-hooks/refs -- Автоматический игнор в рамках DIRECT-288723
                createPortal(<FixedContainer isSticky={isSticky}>{children}</FixedContainer>, drawerRef.current)
            ) : (
                <FixedContainer isSticky={isSticky}>{children}</FixedContainer>
            )}
        </VStack>
    );
};
